import Raven from "raven-js"

export default Raven



// WEBPACK FOOTER //
// ./src/utils/raven.js